<template>
  <nav class="ima-navigation">
    <ul style="ima-navigation__list" v-if="!isForcedPasswordChange">
      <li class="ima-navigation__item">
        <router-link :to="{name: routes.DASHBOARD}" class="ima-navigation__link">
          <b-icon icon="dashboard" size="is-medium" type="is-white" class="ima-navigation__icon"></b-icon>
          <span class="ima-navigation__label">Dashboard</span>
        </router-link>
        </li>
        <li>
        <router-link v-if="canNavigateToRoute(routes.SIGNS)" :to="{name: routes.SIGNS}" class="ima-navigation__link">
          <b-icon icon="featured_play_list" size="is-medium" type="is-white" class="ima-navigation__icon"></b-icon>
          <span class="ima-navigation__label">Schilder</span>
        </router-link>
        </li>
        <li>
        <router-link v-if="canNavigateToRoute(routes.SLOGAN_LIST)" :to="{name: routes.SLOGAN_LIST}" class="ima-navigation__link">
          <b-icon icon="textsms" size="is-medium" type="is-white" class="ima-navigation__icon"></b-icon>
          <span class="ima-navigation__label">Slogans</span>
        </router-link>
        </li>
        <li>
        <router-link v-if="canNavigateToRoute(routes.EXHIBITIONS)" :to="{name: routes.EXHIBITIONS}" class="ima-navigation__link">
          <b-icon icon="date_range" size="is-medium" type="is-white" class="ima-navigation__icon"> </b-icon>
          <span class="ima-navigation__label">Messen</span>
        </router-link>
        </li>
        <li>
        <router-link v-if="canNavigateToRoute(routes.SHOPPING_CART)" :to="{name: routes.SHOPPING_CART}" class="ima-navigation__link">
          <b-icon icon="shopping_cart" size="is-medium" type="is-white" class="ima-navigation__icon"> </b-icon>
          <span class="ima-navigation__label">WARENKORB</span>
          <span v-if="itemsInShoppingCart" class="tag is-danger ima-navigation__tag">{{itemsInShoppingCart}}</span>
        </router-link>
        </li>
        <li>
        <router-link v-if="canNavigateToRoute(routes.USERS)" :to="{name: routes.USERS}" class="ima-navigation__link">
          <b-icon icon="supervisor_account" size="is-medium" type="is-white" class="ima-navigation__icon"> </b-icon>
          <span class="ima-navigation__label">Benutzer</span>
        </router-link>
        </li>
        <li>
        <router-link v-if="canNavigateToRoute(routes.SETTINGS)" :to="{name: routes.SETTINGS}" class="ima-navigation__link">
          <b-icon icon="settings" size="is-medium" type="is-white" class="ima-navigation__icon"> </b-icon>
          <span class="ima-navigation__label">Einstellungen</span>
        </router-link>
        </li>
        <li>
          <a href="https://data.ima-international.com/s/384AexWQNEnbf3C" target="_blank" class="ima-navigation__link">
            <b-icon icon="help" size="is-medium" type="is-white" class="ima-navigation__icon"> </b-icon>
            <span class="ima-navigation__label">Hilfe</span>
          </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import routes from '@/mixins/routes'
import { canNavigateToRoute } from '@/services/permissions'

export default {
  name: 'ima-navigation',
  mixins: [routes],
  data () {
    return {}
  },
  methods: {
    canNavigateToRoute (routename) {
      return canNavigateToRoute(routename)
    }
  },
  computed: {
    ...mapState(['shoppingCart']),
    ...mapGetters(['itemsInShoppingCart', 'isForcedPasswordChange'])
  }
}
</script>


<style scoped lang="scss">
@import '../scss/settings';

.ima-navigation {
  animation: 0.6s slideIn;
  background: #000;
  min-width: $nav-width;

  &__list {
    display: flex;
    flex-direction: column;
  }

  &__item {
    display: flex;
    flex-direction: column;
  }

  &__link {
    align-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-bottom: 1px solid darken($primary, 5);
    display: flex;
    justify-content: center;
    padding: 0.8rem 0.5rem;
    position: relative;
    transition: background-color 0.1s ease-in, color 0.1s ease-in;

    &.router-link-active {
      background-color: darken($primary, 2);
      color: #dedede;
    }

    &:hover {
      background-color: lighten($primary, 1);

      .ima-navigation__label {
        color: #fff;
      }
    }
  }

  &__icon {
  }

  &__label {
    font-size: 0.7rem;
    text-transform: uppercase;
    padding-top: 0.2rem;
  }

  &__tag {
    position: absolute;
    right: 1.9em;
    top: 0.3em;
    padding: 1em 0.7em;
    border-radius: 50%;
    font-weight: 800;
  }

  @keyframes slideIn {
    0% {
      transform: translate(-100%, 0);
    }
    100% {
      transform: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue